import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Modal, Form, TextArea, Button } from 'semantic-ui-react';

import cm from 'helpers/commons';
import toastr from 'helpers/toastr';

import * as com_action from 'actions/company';

class PushMessageModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: ''
    };
  }

  // 입력
  handleChange = (e, { name, value }) => {
    if (value.length > 200) {
      toastr('top-right', 'warning', '200자 이하로 입력해주세요.');
    } else {
      this.setState({ [name]: value });
    }
  };

  // 전송
  handleSubmit = async (e) => {
    e.preventDefault();
    const result = confirm('전체 사용자에게 푸시메세지가 전송되는 것에 유념해주시길 바랍니다. 전송 하시겠습니까?');
    if (!result) {
      return;
    }

    const { content } = this.state;

    if (!cm.valueCheck(content) && content.length <= 200) {
      const params = {
        // push : JSON.parse(JSON.stringify({ title, content }))
        push: {
          content
        }
      };

      try {
        const { comAPI } = this.props;
        await comAPI.pushAdd(params);

        const { closeModal } = this.props.modalFn;
        closeModal();

        toastr('top-right', 'success', '전송 되었습니다.');

        this.setState({ content: '' });
      } catch (e) {
        toastr('top-right', 'error', '일시적인 오류로 푸시 메세지를 전송하지 못했습니다. 다시 시도해주세요.');
      }
    } else {
      toastr('top-right', 'warning', '50자 이하로 입력해주세요.');
    }
  };

  // 취소
  handleCancel = () => {
    if (confirm('취소하신 메세지는 다시 보낼 수 없습니다. 취소하시겠습니까?')) {
      this.setState({ content: '' });

      const { closeModal } = this.props.modalFn;
      closeModal();
    }
  };

  render() {
    const { title, content } = this.state;
    const { open } = this.props.modalFn;

    return (
      <Modal className="push-modal modal-medium" open={open} onClose={this.handleCancel}>
        <Modal.Header>푸시메세지 작성</Modal.Header>

        <Modal.Content>
          <Form>
            <div className="row" style={{ marginBottom: '5px' }}>
              <div className="left">
                <span>수신</span>
              </div>
              <div className="right">
                <span>전체 사용자 (일시정지 및 휴면 상태의 사용자에게 발송되지 않습니다.)</span>
              </div>
            </div>
            <div className="row">
              <div className="left">
                <span>내용</span>
              </div>
              <div className="right">
                <TextArea
                  placeholder="200자 이하로 입력해주세요."
                  name="content"
                  value={content}
                  style={{ maxLength: 200 }}
                  onChange={this.handleChange}
                />
              </div>
              <div
                style={{ float: 'right', padding: '5px 10px 0px 10px', color: 'rgb(201 201 201)' }}
              >{`${content.length}/200`}</div>
            </div>
          </Form>
        </Modal.Content>

        <Modal.Actions>
          <Button inverted color="grey" onClick={this.handleCancel} content="취소" />
          <Button positive content="전송" onClick={this.handleSubmit} />
        </Modal.Actions>
      </Modal>
    );
  }
}

PushMessageModal = connect(
  (state) => ({
    add: state.company.add
  }),
  (dispatch) => ({
    comAPI: bindActionCreators(
      {
        pushAdd: com_action.PushMessageAdd
      },
      dispatch
    )
  })
)(PushMessageModal);

export default PushMessageModal;
